import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.75 17.5v-4.375c0-.492.383-.875.875-.875h8.367l-1.996 1.996a.843.843 0 0 0 0 1.23.843.843 0 0 0 1.23 0l3.5-3.5a.843.843 0 0 0 0-1.23l-3.5-3.5a.843.843 0 0 0-1.23 0 .843.843 0 0 0 0 1.23l1.996 2.024H7.625A2.626 2.626 0 0 0 5 13.125V17.5c0 .465.383.875.875.875a.9.9 0 0 0 .875-.875"
    }, null, -1)
  ]))]))
}
export default { render: render }